import styled, { keyframes } from "styled-components";

const pulse = keyframes`
    0% {
        opacity: 1;
        transform: scale(1);
    }

    50% {
        opacity: 0.6;
        transform: scale(0.96);
    }

    100% {
        opacity: 1;
        transform: scale(1);
    }
`;

export const Content = styled.div`
    flex: 1;
    display: flex;
    z-index: 1;
    justify-content: center;
    align-items: center;
    margin-top: 15%;
`;

export const LogoImage = styled.img`
    width: 160px;
    max-width: 70vw;
    height: auto;
    animation: ${pulse} 1.5s ease-in-out infinite;
`;
